export default "__VITE_ASSET__BN77OK4g__"